const HOURS_IN_A_DAY = 24
const SECONDS_IN_AN_HOUR = 3600
const MILISECONDS_IN_A_SECOND = 1000
const MILISECONDS_IN_A_DAY = HOURS_IN_A_DAY * SECONDS_IN_AN_HOUR * MILISECONDS_IN_A_SECOND

const SOURCE_DEVICE_TYPE = Object.freeze({
  CAM: 'CAM',
  GPS: 'GPS',
})

const CDM_ALERT_CODES = Object.freeze({
  DEVICE_DISARMED: 1, // Device disarmed
  DOOR_OPEN: 4, // Door 1 open
  VIBRATION: 10, // Vibration
  ENGINE_TEMPERATURE: 18, // Engine temperature
  DOOR_CLOSE: 19, // Door 1 close
  MOTION_DETECTED: 122, // Motion Detected (with Scope)
  CAMERA_OFF: 126, // Camera Off
  MOVEMENT: 127, // Movement (with Scope)
  BUZZER_FAULTY: 128, // Buzzer Faulty (with Scope)
  MOTION_FAULTY: 129, // Motion Faulty (with Scope)
})

const DOOR_STATUS = Object.freeze({
  OPEN: 0,
  CLOSED: 1,
})

const BUZZER_STATUS = {
  ENABLE: 'enable',
  DISABLE: 'disable',
}

export { MILISECONDS_IN_A_DAY, SOURCE_DEVICE_TYPE, CDM_ALERT_CODES, DOOR_STATUS, BUZZER_STATUS }
